import React, { useState, useEffect } from 'react';

import useFetch from '../../Services/useFetch';
import { useAuth } from '../../Services/AuthContext';
import { endpoints, RoleNames } from '../../utils/Constants';
import SupplierDetail from '../Cards/SupplierDetail'
import {  useFormikContext,getIn } from 'formik';
import ErrorMessage from './ErrorMessage'
import { useEdit } from '../../Services/EditContext';
import LoadingAnimation from './LoadingAnimation';
import Selector from './Selector';

const AdminSupplierSelector = ({ route, value, id,isMulti }) => {
    const getSelector = (suppliers) => {
        return suppliers ? suppliers.map(supplier => { return { label: supplier.companyName + ' | ' + supplier.firstName + ' | ' + supplier.lastName + ' | ' + supplier.email, value: supplier.id } }) : [];
    }


    const { setFieldValue,errors,touched } = useFormikContext();
    const [edit] = useEdit();
    const [suppliers, loading, error] = useFetch(edit?endpoints.getAllSuppliers:null);
    const [suppliersSelect, setsuppliersSelect] = useState(suppliers ? getSelector(suppliers) : []);
    const [supplier, setSupplier] = useState();
    const [selectValue, setSelectValue] = useState();
    useEffect(() => {
        const select = getSelector(suppliers);
        setsuppliersSelect(select)
    }, [suppliers]);
    useEffect(() => {
        if (suppliersSelect) {
            if (isMulti) {
                const v = suppliersSelect.filter(xx => { return value.find(x => x === xx.value) });
                setSelectValue(v);
            }
            else {
                const c = suppliers?.find(xx => { return xx.value === value });
                setSupplier(c);
                const v = suppliersSelect.find(xx => { return xx.value === value });
                setSelectValue(v);
                setFieldValue('supplier', c);
            }
        }
    }, [isMulti,suppliers,suppliersSelect, value, setFieldValue]);


    const onSelectChange = (newValue) => {
        if (isMulti) {
            setFieldValue(id, newValue.map(x => x.value));
        }
        else
        {
            setFieldValue(id, newValue.value);
        }
    }



    return <React.Fragment>
        {edit && suppliersSelect ? <h1>Select Supplier</h1> : null}
        {edit && suppliersSelect ? <Selector hideAllButton isMulti={isMulti} invalid={getIn(errors, id) && getIn(touched, id)} options={suppliersSelect} onChange={onSelectChange} value={selectValue} /> : ''}
        {!edit && supplier ? <SupplierDetail route={route} supplier={supplier} /> : null}
        {loading ? <LoadingAnimation height={'50px'} />  : ''}
        {error ? <p> error</p> : ''}
    </React.Fragment>

}
const SupplierSelector = ({ route, name, id,isMulti, isClientView }) => {

    const [user] = useAuth();
    const [edit] = useEdit()
    const {  setFieldValue,values, ...rest } = useFormikContext();
    useEffect(() => {
        if ( edit) {
            if (user.role === RoleNames.Supplier) {
                if (values[id] !== user.supplierId) {
                    setFieldValue(id, user.supplierId);
                }
            }
        }
    }, [ user, setFieldValue, name, values,edit,id]);

    if (user.role === RoleNames.Admin) {
        return <React.Fragment>
            {edit ? <AdminSupplierSelector  isMulti={isMulti}  route={route} id={id} {...rest} value={values[id]} /> : null}
            <ErrorMessage name={id} />
            <SupplierDetail route={route} supplier={values.supplier} isClientView={isClientView} />
        </React.Fragment >
    }
    else if (user.canViewSupplierInfo) {
        return <React.Fragment>
           
            {!edit && values.supplier ? <SupplierDetail route={route} supplier={values.supplier} isClientView={isClientView} /> : null}
            <ErrorMessage name={id} />
        </React.Fragment>
    }
    else{
        return <ErrorMessage name={id} />;
    }
}

export default SupplierSelector; 